import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Skeleton } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function FilterForm({
    filterOptions,
    onChangeCallback,
    onCloseCallback,
    filterOptionsTitle,
    suspend,
}) {
    const handleChange = (event) => {
        onChangeCallback(event.target.value);
    };
    return (
        <div>

            {suspend ? (
                <Skeleton
                    style={{
                        width: "250px",
                        height: "90px",
                        margin: "0px",
                        paddingTop: "0px",
                    }}
                    animation="wave"
                />
            ) : (
                <>
                    <InputLabel id={`multiple-checkbox-label-${filterOptionsTitle}-id`}>
                        {filterOptionsTitle}
                    </InputLabel>
                    <Select
                        labelId={`multiple-checkbox-label-${filterOptionsTitle}`}
                        id={`multiple-checkbox-label-${filterOptionsTitle}-checkbox-id`}
                        multiple
                        value={filterOptions.filter((e) => e.selected)}
                        onChange={(e) => {
                            handleChange(e);
                        }}
                        input={<OutlinedInput label="Tag" />}
                        renderValue={(selected) => selected.map((e) => e.text).join(", ")}
                        MenuProps={MenuProps}
                        style={{ width: "250px" }}
                        onClose={(e) => { onCloseCallback(e) }}
                    >
                        {filterOptions.map((name) => (
                            <MenuItem key={name} value={name}>
                                <Checkbox checked={name.selected} />
                                <ListItemText primary={name.text} />
                            </MenuItem>
                        ))}
                    </Select>
                </>

            )}
        </div>
    );
}
